// Smooth scroll helper that works with Lenis (falls back to native).
export const scrollToId = (target) => {
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis) {
    lenis.scrollTo(target, { offset: -70, duration: 1.2 });
    return;
  }
  const el = document.querySelector(target);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};
